import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Form, Table, Button } from 'semantic-ui-react';

import cm from 'helpers/commons';

class TransferingList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { checkStaff } = this.props;

    const { staffLinkAdd } = this.props.TransferingFn;
    let checkedList = '';
    let length = 0;

    if (checkStaff && checkStaff.data) {
      const { valid } = checkStaff.data.check;
      length = valid.length;

      let validRow = valid
        ? valid.map((item, idx) => {
            return (
              <Table.Row key={idx}>
                <Table.Cell>
                  <span>{length - idx}</span>
                  {item.value}
                </Table.Cell>
              </Table.Row>
            );

            // return(
            //   <List.Item key={idx}>
            //     <List.Content>
            //       <List.Header as='a'>
            //         <span className="trans-num">{length-idx}</span>
            //         {item.value}
            //       </List.Header>
            //     </List.Content>
            //   </List.Item>
            // );
          })
        : '';

      checkedList = (
        <Table basic="very" celled collapsing>
          <Table.Body>{validRow}</Table.Body>
        </Table>
      );
    }

    return (
      <div>
        <div className="step-txt">
          Step3. 전송 목록
          <span className="count">성공 {length}</span>
        </div>

        <div className="list-scroll">{checkedList}</div>

        <div>
          <Button color={checkedList === '' ? 'grey' : 'green'} fluid onClick={staffLinkAdd}>
            회원가입 링크 전송
          </Button>
        </div>
      </div>
    );
  }
}

TransferingList = connect(
  (state) => ({
    checkStaff: state.company.check
  }),
  (dispatch) => ({})
)(TransferingList);

export default TransferingList;
